import { useEffect, useState } from 'react';
import { adminApi } from '../../../services/adminApi';

interface AuditRow {
  id: string;
  adminId: string;
  adminEmail: string;
  action: string;
  targetType: string | null;
  targetId: string | null;
  payload: any;
  ip: string | null;
  createdAt: string;
}

export default function AuditTab() {
  const [rows, setRows] = useState<AuditRow[]>([]);
  const [loading, setLoading] = useState(false);

  async function refresh() {
    setLoading(true);
    try {
      const res = await adminApi.get('/audit', { params: { limit: 100 } });
      setRows(res.data.audit);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    refresh();
  }, []);

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold">Admin audit log</h2>
        <button
          onClick={refresh}
          className="px-3 py-1.5 text-sm bg-white/5 hover:bg-white/10 border border-white/10 rounded-lg"
        >
          {loading ? '\u2026' : 'Refresh'}
        </button>
      </div>

      <div className="bg-white/5 border border-white/10 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-black/30 text-gray-400 text-xs uppercase">
            <tr>
              <th className="text-left px-3 py-2">When</th>
              <th className="text-left px-3 py-2">Admin</th>
              <th className="text-left px-3 py-2">Action</th>
              <th className="text-left px-3 py-2">Target</th>
              <th className="text-left px-3 py-2">Detail</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-white/5 align-top">
                <td className="px-3 py-2 text-gray-300 whitespace-nowrap">
                  {new Date(r.createdAt).toLocaleString()}
                </td>
                <td className="px-3 py-2 text-gray-300">{r.adminEmail}</td>
                <td className="px-3 py-2 font-mono text-xs">{r.action}</td>
                <td className="px-3 py-2 font-mono text-xs text-gray-400">
                  {r.targetType ?? '\u2014'}
                  {r.targetId ? ` / ${r.targetId.slice(0, 8)}\u2026` : ''}
                </td>
                <td className="px-3 py-2 font-mono text-[10px] text-gray-400 max-w-[280px] truncate">
                  {r.payload ? JSON.stringify(r.payload) : ''}
                </td>
              </tr>
            ))}
            {rows.length === 0 && !loading && (
              <tr>
                <td colSpan={5} className="text-center px-3 py-6 text-gray-400">
                  No audit entries yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
